<template>
  <section class="hero-two">
    <svg class="shape-1" width="252" height="347" viewBox="0 0 252 347" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.2">
        <path d="M248.659 269.246C248.32 269.928 247.982 270.439 247.643 270.951C243.411 278.284 233.086 284.082 233.086 284.082L188.906 309.832L135.931 340.677C129.748 344.277 122.113 344.3 115.909 340.738L0 274.191L110.195 209.048C118.151 204.444 125.937 194.042 125.937 184.151C125.937 183.98 125.937 181.081 125.937 175.966V181.081C125.937 191.313 133.047 204.103 141.849 209.219L235.964 263.959C236.641 264.3 237.148 264.641 237.487 264.812C238.164 265.153 238.841 265.323 239.518 265.664C240.195 265.835 240.872 266.006 241.549 266.176H241.719C242.227 266.176 242.904 266.347 243.411 266.176C243.919 266.176 244.596 266.176 245.104 266.006C245.273 266.006 245.443 265.835 245.612 265.835C245.951 265.664 246.289 265.664 246.628 265.494C246.797 265.323 247.135 265.153 247.305 265.153C247.643 264.982 247.982 264.812 248.32 264.471C248.49 264.3 248.659 264.13 248.997 263.959C249.167 263.789 249.336 263.618 249.505 263.448C249.844 262.936 250.182 262.424 250.521 261.913C250.69 261.572 250.859 261.231 251.029 260.719C251.198 260.378 251.198 260.207 251.367 259.866V259.696C251.536 259.014 251.706 258.161 251.875 257.308C251.367 261.913 250.352 266.006 248.659 269.246Z" fill="#F6B09D"/>
        <path d="M251.369 257.963C251.369 257.451 251.538 256.938 251.538 256.254C251.369 257.109 251.201 257.963 251.032 258.647V258.818C250.863 259.16 250.863 259.331 250.694 259.673C250.525 260.014 250.357 260.527 250.188 260.869C249.85 261.382 249.513 261.895 249.175 262.407C249.006 262.578 248.837 262.749 248.668 262.92C248.5 263.091 248.331 263.262 247.993 263.433C247.655 263.604 247.318 263.946 246.98 264.116C246.811 264.287 246.474 264.458 246.305 264.458C245.967 264.629 245.63 264.8 245.292 264.8C245.123 264.8 244.954 264.971 244.786 264.971C244.279 265.142 243.773 265.142 243.097 265.142C242.591 265.142 242.085 265.142 241.409 265.142H241.24C240.565 264.971 239.89 264.971 239.215 264.629C238.539 264.458 237.864 264.116 237.189 263.775C236.851 263.604 236.345 263.433 235.67 262.92L141.807 208.056C133.029 202.928 125.938 190.281 125.938 179.855V174.727V-76.8614C125.938 -87.1164 132.86 -91.3893 141.807 -86.2618L235.838 -31.3977C244.617 -26.2702 251.876 -13.6224 251.876 -3.1965V253.691C251.707 255.229 251.538 256.596 251.369 257.963Z" fill="#983628"/>
        <path d="M125.751 -76.5522C125.751 -76.5522 125.582 183.076 125.751 184.103C125.751 194.036 117.997 204.483 110.074 209.107L0.337641 274.528L0.337641 201.4L0.221593 124.651L0.0291272 -2.63766L0.000488281 -21.5782C0.000488281 -21.5782 111.085 -87.1703 112.097 -87.5128C112.097 -87.5128 123.222 -92.9931 138.225 -87.6841C130.808 -89.9104 125.751 -85.4577 125.751 -76.5522Z" fill="#FF4337"/>
      </g>
    </svg>
    <svg class="shape-2" width="285" height="476" viewBox="0 0 285 476" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M391.737 202.542C391.991 203.971 374.975 298.295 374.975 298.295C373.845 302.903 371.664 307.202 368.605 310.849C365.545 314.496 361.692 317.391 357.35 319.305L154.768 394.795C150.799 396.11 146.608 396.552 142.482 396.091C138.357 395.629 134.395 394.276 130.868 392.122C136.38 394.921 141.364 392.239 142.833 384.784L159.064 294.146C159.672 289.422 159.17 284.64 157.598 280.183C156.025 275.725 153.426 271.717 150.01 268.48L145.648 264.82L150.06 268.522C153.757 271.343 158.074 273.248 162.668 274.084C167.261 274.921 172.004 274.666 176.518 273.34L219.685 257.425L378.708 198.215L378.922 197.96C385.422 195.507 387.512 190.571 384.97 185.658C389.05 190.342 391.431 196.284 391.737 202.542Z" fill="#13588A"/>
      <path d="M371.44 145.823L382.467 182.564C389.036 188.075 387.766 195.089 379.63 198.168L177.04 273.565C172.526 274.891 167.784 275.146 163.19 274.31C158.597 273.473 154.279 271.568 150.583 268.747L69.7988 200.98L128.374 179.223L248.483 133.434L350.322 94.61L371.44 145.823Z" fill="#BDD4EF"/>
      <path d="M65.297 223.354L69.7559 201.031L150.54 268.798C153.956 272.036 156.555 276.044 158.127 280.501C159.7 284.958 160.202 289.741 159.594 294.464L143.363 385.103C141.839 393.641 135.203 396.154 128.584 390.602L55.5156 329.307C49.8163 324.526 47.2019 316.976 48.6446 309.678C52.7448 288.937 60.5929 248.201 65.6392 222.946" fill="#007CC2"/>
    </svg>
    <svg class="shape-3" width="249" height="219" viewBox="0 0 249 219" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M166.691 105.211C173.525 107.001 180.354 107.252 187.104 107.876C201.634 109.217 216.165 110.834 230.802 110.556C233.765 110.496 236.601 111.021 239.263 112.421C245.49 115.686 248.96 122.541 247.923 129.607C246.9 136.494 241.397 142.15 234.428 143.211C232.03 143.576 229.582 143.536 227.15 143.593C212.997 143.935 198.965 142.3 184.887 141.232C183.936 141.154 182.954 141.142 182.02 141.275C181.811 141.308 181.428 142.248 181.557 142.394C182.705 143.637 183.901 144.847 185.177 145.993C192.802 152.833 200.459 159.641 208.084 166.481C209.538 167.788 210.976 169.127 212.221 170.613C217.041 176.426 217.471 184.215 213.419 190.401C209.591 196.245 202.45 198.959 195.504 197.218C192.119 196.371 189.246 194.6 186.661 192.277C173.964 180.855 161.298 169.4 148.552 158.027C144.546 154.461 140.315 151.156 136.149 147.786C135.438 147.205 134.517 146.399 133.587 147.277C133.153 147.683 132.963 148.542 132.949 149.19C132.845 156.042 132.724 162.893 132.764 169.76C132.825 182.361 130.372 194.565 127.001 206.611C126.412 208.703 125.599 210.827 124.446 212.645C119.065 221.054 107.148 220.902 101.836 212.45C100.249 209.929 99.2888 207.163 99.1977 204.151C99.0719 200.474 98.914 196.815 98.9976 193.138C99.2485 182.123 99.6283 171.108 99.9436 160.094C99.9859 158.393 99.9636 156.676 99.8771 154.96C99.8252 153.956 98.5668 153.28 97.7152 153.801C96.0601 154.827 94.4375 155.918 92.831 157.009C82.7909 163.928 72.6859 170.75 62.1762 176.926C59.2353 178.653 56.2622 180.348 53.1591 181.719C46.6796 184.593 39.9003 184.649 33.1152 183.07C31.0362 182.591 28.9392 181.595 27.1956 180.354C19.6724 174.987 20.1176 164.263 27.9589 159.409C30.0478 158.122 32.3477 157.32 34.7616 156.842C37.4328 156.314 39.8444 155.172 42.0287 153.545C53.3355 145.066 64.6422 136.572 75.9327 128.045C76.2539 127.801 76.3001 127.201 76.4757 126.763C75.585 125.341 73.9752 125.477 72.6538 125.222C56.6204 122.25 40.5872 119.359 24.5381 116.501C22.395 116.119 20.1568 116.176 18.0137 115.795C15.3873 115.351 12.6805 114.939 10.2134 114.025C4.1989 111.778 0.459167 106.171 0.388624 99.8875C0.316879 93.2634 4.21003 87.6133 10.5625 85.2423C13.5538 84.1304 16.6764 83.7144 19.8642 83.525C27.721 83.0599 35.3907 84.3447 43.0449 85.7753C49.2327 86.9357 55.4365 88.0475 61.6081 89.1756C62.1319 87.0196 60.6958 86.2311 59.7423 85.2465C50.7237 75.9655 41.7052 66.6844 32.6385 57.4522C28.5173 53.2395 24.9581 48.6037 21.9289 43.5449C20.1308 40.5388 19.2175 37.2865 19.3338 33.7553C19.6518 23.5019 29.8411 17.7647 38.6682 22.9973C40.9597 24.3497 43.0111 26.1402 44.9982 27.931C57.5341 39.1593 70.0702 50.4201 82.526 61.7459C88.6811 67.3281 95.0447 72.6342 101.633 77.6803C102.214 78.1156 102.811 78.5346 103.441 78.9211C104.812 79.7746 105.922 79.3172 105.981 77.8269C106.055 75.8669 106.032 73.9072 106.041 71.9474C105.99 57.5004 106.019 43.0531 105.855 28.6065C105.806 23.6505 106.416 18.8219 107.511 14.0562C108.906 7.97766 112.352 3.34945 118.351 1.17412C129.416 -2.84935 141.378 5.56288 140.132 17.3097C138.168 35.6672 139.617 53.9964 139.135 72.3324C139.107 73.5634 139.079 74.7783 139.148 76.009C139.266 77.6606 138.485 79.8336 140.018 80.7838C141.793 81.8951 143.042 79.8175 144.279 78.8414C156.162 69.4864 167.965 60.0345 179.298 49.985C182.043 47.5621 184.772 45.1229 187.582 42.7807C189.075 41.5445 190.649 40.308 192.353 39.4274C199.152 35.9211 206.821 36.9791 211.992 42.0141C217.034 46.92 218.657 55.061 215.959 61.6949C214.139 66.1554 211.27 69.9555 207.074 72.0597C201.737 74.7186 197.451 78.6694 192.907 82.3135C184.717 88.8696 176.609 95.5389 168.484 102.176C167.762 102.778 166.845 103.283 166.691 105.178L166.691 105.211Z" fill="#FF4337"/>
    </svg>
    <img v-if="payload.left_image_one" class="image-left-one" :src="payload.left_image_one.url" :alt="payload.left_image_one.alt" />
    <img v-if="payload.right_image_one" class="image-right-one" :src="payload.right_image_one.url" :alt="payload.right_image_one.alt" />
    <b-container>
      <b-row align-h="center">
        <b-col class="content d-flex flex-column justify-content-between text-center" cols="12" xl="6">
          <div class="content__box d-flex flex-column align-items-center text-center">
            <div class="content__title-box">
<!--              <img v-if="payload.show_label" class="content__logo" src="../../assets/media/logo/ep-logo-black.svg" alt="EP logo" />-->
              <h1 v-if="payload.title" v-html="payload.title" />
            </div>
            <div class="box">
              <a class="button" v-if="payload.link && payload.link.url && payload.link.title" :href="payload.link.url" :target="payload.link.target">{{ payload.link.title }}</a>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <img @click="scrollToSecondSection" class="content__arrow" alt="chevron-down-icon" role="button"
                 src="../../assets/media/icons/chevron-down.svg"/>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  name: "HeroImagesTwo",
  props: ['payload'],
  methods: {
    scrollToSecondSection() {
      const sections = document.querySelectorAll('main section');
      if (sections.length > 1) {
        sections[1].scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
}
</script>

<style lang="scss">
section.hero-two{
  position: relative;
  background: #F2F8FF;
  color: $black;
  padding-top: 80px;
  padding-bottom: 80px;
  z-index: 1;

  @include media-breakpoint-up(lg){
    padding-top: 137px;
    padding-bottom: 24px;
  }

  .shape-1 {
    position: absolute;
    inset: 0;
  }

  .shape-2 {
    position: absolute;
    top: 43%;
    right: 0;
  }

  .shape-3 {
    position: absolute;
    bottom: 170px;
    left: 10px;
  }

  h1 {
    @extend %header-1;
    z-index: 1;

    & span {
      position: relative;

      &::after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 100%;
        background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjM0IiBoZWlnaHQ9IjUyIiB2aWV3Qm94PSIwIDAgMjM0IDUyIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0xMC4zNjQ1IDUxLjgzNDFDNS4xNDY1NiA1Mi4wNDM4IDIuNjM2OTkgNDguMjU1MCAxLjEyNDc1IDQ0Ljg1NDVDLTAuOTQ2MjIzIDQwLjEwMjAtMC41NDMzMDcgMzQuMzI5NSAyLjEzNTMgMjkuNjYwN0M1LjM4NDggMjAuMDk5MiAxNC43MzYxIDkuNTkxNzggMjYuNTQ4OSA5LjA2NjU1QzQxLjEwNjIgOC40MjA0MCA1NS42NTY2IDcuNzc0NDggNzAuMjEzOSA3LjEyODM0QzEyMS4xNTQgNC44NjcyMSAxNzIuMDk0IDIuNjA2MTEgMjIzLjAzNSAwLjM0NDk3NUMyMjcuNzg0IDAuMTM1MjQ2IDIzMC43NjIgMy45MjQwOSAyMzIuMjc0IDcuMzY0NTlDMjM0LjM0NSAxMi4wNzcxIDIzMi44NTUgMTcuODQ5NiAyMzEuMjY0IDIyLjUxODRDMjI4LjAxNCAzMi4wNzk5IDIxOC42NjMgNDIuNTg3MyAyMDYuODUgNDMuMTEyNUMxOTIuMjkzIDQzLjc1ODcgMTc3Ljc0MyA0NC40MDQ2IDE2My4xODUgNDUuMDUwN0MxMTIuMjQ1IDQ3LjMxMTkgNjEuMzA0NyA0OS41NzMwIDEwLjM2NDUgNTEuODM0MVoiIGZpbGw9IiNCREQ0RUYiLz48L3N2Zz4=');
        background-repeat: no-repeat;
        background-position: center bottom;
        background-size: contain;
        z-index: -1;
        pointer-events: none;
      }
    }
  }

  .content {
    position: relative;
    z-index: 3;
    min-height: 640px;
    gap: 32px;

    @include media-breakpoint-up(lg){
      padding: 0;
    }

    &__box {
      gap: 40px;
    }

    &__logo {
      position: absolute;
      top: -80%;
      left: 0;
      max-width: 115px;
      object-fit: cover;
    }

    &__title-box {
      max-width: 660px;
      display: flex;
      justify-content: center;
      margin: 220px 0 0 0;
      position: relative;
    }

    &__arrow {
      padding: 9px;
      border-radius: 360px;
      background: #FFF;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .box {
    display: flex;
    justify-content: center;
  }

  .button {
    font-size: 20px;
    color: white;
    font-weight: 500;
    padding: 10px 32px;
    background-color: #007CC2;
    border-radius: 40px;
  }

  .image-left-one {
    position: absolute;
    width: 400px;
    height: 228px;
    object-fit: cover;
    transform: rotate(2.087deg);
    border-radius: 8px;
    bottom: 60px;
    left: 100px;
    z-index: 1;

    @include media-breakpoint-down(sm){
      width: 300px;
      left: 10px;
    }
  }

  .image-right-one {
    position: absolute;
    border-radius: 8px;
    width: 352px;
    height: 218px;
    transform: rotate(-1.929deg);
    object-fit: cover;
    z-index: 1;
    top: 160px;
    right: 102px;

    @include media-breakpoint-down(lg){
      top: 30px;
    }

    @include media-breakpoint-down(sm){
      width: 300px;
      right: 10px;
    }
  }
}
</style>
